export default class bibliography2 {
   constructor(entries) {
      this.bibliographyBinds = this.bibliographyBinds.bind(this);
      this.generateBibliographyEntry = this.generateBibliographyEntry.bind(this);
      this.genericBinds();

      this.createBibs(entries);
   }

   createBibs(entries) {
      const t = this;

      this.bibs = [];

      entries.forEach(entry => {
         if(entry.sources) {
            entry.sources.forEach((source, idx) => {
               let ssssrc = {
                  entry_id: entry.id,
                  entry_slug: entry._slug,
                  rel: entry,
                  source: source,
                  source_idx: idx,
               }
               this.bibs.push(ssssrc);
               t.generateBibliographyEntry(ssssrc);
            });
         }
      });
      
      $('.bib-link').removeClass('disabled');
      
      setTimeout(function(){
         t.bibliographyBinds();
         // t.saveBibs();
      }, 200);
   }

   // Function to parse raw bibliography entries
   generateBibliographyEntry(bib) {
      let source = bib.source;
      bib.el = bib.rel._box.get(0);
      
      if($(`.bib--content [data-title="${source.title}"]`).length == 0) {
         let bibHtml = $(`<div 
         class="bib--content--entry"
         data-year="${source.year}"
         data-title="${source.title}"
         data-names="${source.authors}">
         <div class="id"><span data-id="${bib.entry_id}">[#${bib.entry_id}]</span></div>
            <div class="year">${source.year}</div>
            <div class="title">${source.title}</div>
            <div class="names">${source.authors}</div>
            </div>`);

         $('.bib--content').append(bibHtml);
         source.el = bibHtml.get(0);
      } else {
         let ids = $(`.bib--content [data-title="${source.title}"] .id`).html();
         ids += ` <span data-id="${bib.entry_id}">[#${bib.entry_id}]</span>`;
         $(`.bib--content [data-title="${source.title}"] .id`).html(ids);
      }
   }

   genericBinds() {
      $('.bib-link').on('click', function(e){
         if(!e.metaKey && !e.ctrlKey && !e.shiftKey) {
            e.preventDefault();
            $('body').removeClass('about-open');
            $('body').toggleClass('bib-open');
         }
      });

      $('.bib--close').on('click', function(e){
         e.preventDefault();
         $('body').removeClass('bib-open');
      });
   }

   bibliographyBinds() {
      const t = this;
      $('.bib--content a').on('click', function(e){
         if(!e.metaKey && !e.ctrlKey && !e.shiftKey) {
            e.preventDefault();
            window.open($(this).attr('href'));
         }
      });

      $('.bib--content span[data-id]').on('click', function(e){
         e.stopPropagation();
         e.preventDefault();
         let id = $(this).attr('data-id');
         let el = $(`.box[data-id="${id}"]`).get(0);
         if(el) {
            $('body').removeClass('bib-open');
            setTimeout(function(){
               $(el).trigger('click');
            }, 10);
         }
      });

      /*
      t.bibs.forEach(bib => {
         // console.log('bindSingle.el', bib.el);
         if(bib.rel && bib.rel._box) {
            $(bib.el).off('mouseenter click').on('mouseenter', function(){
               try {
                  bib.rel.centerBox(bib.rel._box.get(0))
               } catch(e) {
                  $(bib.el).addClass('no-rel');
                  // console.log(`%c${bib.rel._box} no get`, 'color: #f00;', bib.rel._box);
               }
            }).on('click', function(){
               try {
                  window.preventClick = true;
                  setTimeout(function(){
                     $('body').removeClass('bib-open');
                     $(bib.rel._box).trigger('click');
                  }, 10);
                  setTimeout(function(){
                     window.preventClick = false;
                  }, 400);
               } catch(e) {
                  $(bib.el).addClass('no-rel');
               }
            });
            // bib.binds = true;
         } else {
            $(bib.el).addClass('no-rel');
         }
      });
      */

      this.initIsotope();
   }

   initIsotope() {
      // var $grid = $('.bib--content').isotope({
      // var $grid = $('.bib--content').isotope({
         var iso = new isotope( document.querySelector('.bib--content'), {
         itemSelector: '.bib--content--entry',
         stagger: 0,
         transitionDuration: 0,
         layoutMode: 'vertical',
         getSortData: {
            year: '[data-year]',
            title: '[data-title]',
            names: '[data-names]'
         },
         sortBy: 'title',
         initLayout: true,
      });
      this.iso = iso;

      $('.bib--sort').on('click', function(e){
         e.preventDefault();
         var sortValue = $(this).attr('data-prop');
         if($(this).hasClass('cur')) {
            $(this).toggleClass('asc');
         } else {
            $('.bib--sort').removeClass('cur asc');
            $(this).addClass('cur asc');
         }
         iso.arrange({
            sortBy: sortValue,
            sortAscending: $(this).hasClass('asc')
         });
      });
   }

   /*
   getReferenceOpenBox(tar) {
      const t = this;
      let doiList = [];
      let isbnList = [];

      // Collect all DOIs from [data-doi] elements
      $('.box.open [data-doi].load').each(function() {
         const doi = $(this).attr('data-doi');
         doiList.push({
            doi: doi,
            id: this.dataset.id
         }); // Collect DOI
      });

      // Collect all ISBNs from [data-isbn] elements
      $('.box.open [data-isbn].load').each(function() {
         const isbn = $(this).attr('data-isbn');
         isbnList.push({
            isbn: isbn,
            id: this.dataset.id
         }); // Collect ISBN
      });

      if (doiList.length > 0) {
         this.fetchDOIBatch(doiList, 100);
      }
      if (isbnList.length > 0) {
         this.fetchISBNBatch(isbnList, 100);
      }
   }
   */
   
    /*
   getReferences() {
      const t = this;
      // console.log('getReferences', t);
      let doiList = [];
      let isbnList = [];


      // Collect all DOIs from [data-doi] elements
      $('[data-doi].load').each(function() {
         const doi = $(this).attr('data-doi');
         doiList.push({
            doi: doi,
            id: this.dataset.id
         }); // Collect DOI
      });

      // Collect all ISBNs from [data-isbn] elements
      $('[data-isbn].load').each(function() {
         const isbn = $(this).attr('data-isbn');
         isbnList.push({
            isbn: isbn,
            id: this.dataset.id
         }); // Collect ISBN
      });
      
      // Submit a request for all DOIs with a delay between each request
      if (doiList.length > 0) {
         this.fetchDOIBatch(doiList, 100); // 100ms delay between requests
      }
      
      // Submit a request for all ISBNs with a delay between each request
      if (isbnList.length > 0) {
         this.fetchISBNBatch(isbnList, 100); // 100ms delay between requests
      }
   }
      */
   
   /*
   fetchDOIBatch(doiObjList, delay) {
      const t = this;
      doiObjList.forEach((obj, index) => {
         const doi = obj.doi;
         const id = obj.id;
         // console.log(`loading ${id}`);
         setTimeout(() => {
            let apiUrl = `https://api.crossref.org/works/${doi}`;
            
            fetch(apiUrl)
            .then(response => {
               if (!response.ok) {
                  let errorData = {
                     isError: true,
                     isDOI: true,
                     isISBN: false,
                     doi: doi,
                     id: id
                  };
                  t.bibs.push(errorData);
                  // console.error('Error fetching doi:', response);
                     
                  clearTimeout(window.bibTimeout);
                  window.bibTimeout = setTimeout(function(){
                     // console.log('!response.ok triggered processBibs doi timeout');
                     t.processBibs();
                  }, 2000);
                  throw new Error(`HTTP error! status: ${response.status}`);
               }
               return response.json();
            })
            .then(data => {
               if (data.message) {
                  data.doi = doi;
                  data.message.isDOI = true;
                  data.message.isISBN = false;
                  data.message.id = id;
                  t.bibs.push(data.message);
                  
                  clearTimeout(window.bibTimeout);
                  window.bibTimeout = setTimeout(function(){
                     // console.log('.then(data triggered processBibs doi timeout');
                     t.processBibs();
                  }, 2000);
               } else {
                  // console.log('no data.message', data);
               }
            })
            .catch(error => {
               // let errorData = {
               //    isError: true,
               //    isISBN: false,
               //    doi: doi,
               //    id: id
               // };
               // t.bibs.push(errorData);
               // console.error('Error fetching DOIs:', error);
                  
               //    t.processBibs();
               // }, 2000);
            });
         }, index * delay); // Delay each request by the specified delay (in ms)
      });
   }
   
   fetchISBNBatch(isbnObjList, delay) {
      const t = this;
      // console.log('fetchISBNBatch', isbnObjList);
      isbnObjList.forEach((obj, index) => {
         const isbn = obj.isbn;
         const id = obj.id;
         // console.log(`loading ${id}`);
         // setTimeout(() => {
            let apiUrl = `https://openlibrary.org/api/books?bibkeys=ISBN:${isbn}&format=json&jscmd=data`;
            
            fetch(apiUrl)
            .then(response => {
               if (!response.ok) {
                  let errorData = {
                     isError: true,
                     isISBN: true,
                     isDOI: false,
                     isbn: isbn,
                     id: id
                  };
                  t.bibs.push(errorData);
                  // console.error('Error fetching ISBNs:', response);
                     
                  clearTimeout(window.bibTimeout);
                  window.bibTimeout = setTimeout(function(){
                     // console.log('!response.ok triggered processBibs ISBNs timeout');
                     t.processBibs();
                  }, 2000);

                  // throw new Error(`HTTP error! status: ${response.status}`);
               }
               return response.json();
            })
            .then(data => {
               let entryData = data[`ISBN:${isbn}`];
               if (entryData) {
                  entryData.isISBN = true;
                  entryData.isDOI = false,
                  entryData.isbn = isbn;
                  entryData.id = id;
                  t.bibs.push(entryData);
                  
                  clearTimeout(window.bibTimeout);
                  window.bibTimeout = setTimeout(function(){
                     // console.log('.then(data triggered processBibs ISBN timeout');
                     t.processBibs();
                  }, 2000);
               } else {
                  let entryData = {};
                  entryData.isError = true;
                  entryData.isISBN = true;
                  entryData.isDOI = false,
                  entryData.isbn = isbn;
                  entryData.id = id;
                  t.bibs.push(entryData);
               }
            })
            .catch(error => {
               // let errorData = {
               //    isError: true,
               //    isISBN: true,
               //    isbn: isbn,
               //    id: id
               // };
               // t.bibs.push(errorData);
               // console.error('Error fetching ISBNs:', error);
                  
               //    t.processBibs();
               // }, 2000);
            });
         // }, index * delay); // Delay each request by the specified delay (in ms)
      });
   }
   */
}